import { type RegistrationFlowVersion } from './api/homeOneRegistrationRequest'

type RegistrationFlowExperimentState = {
  isModifyRegistrationExperimentEnabled: boolean
  isStrongPasswordRequired: boolean
}

type RegistrationFlowConfig = RegistrationFlowExperimentState & {
  registrationFlowVersion: RegistrationFlowVersion
}

export const resolveRegistrationFlowConfig = ({
  isModifyRegistrationExperimentEnabled,
  isStrongPasswordRequired,
}: RegistrationFlowExperimentState): RegistrationFlowConfig => {
  return {
    isModifyRegistrationExperimentEnabled,
    isStrongPasswordRequired,
    registrationFlowVersion: isModifyRegistrationExperimentEnabled
      ? 'v4'
      : 'v3',
  }
}
